module.exports = __webpack_public_path__ + "static/media/RightArrow.4b15c945.svg";